import { Component, Input, OnInit } from "@angular/core";
import { QuestionnaireQuestion } from "@models/questionnaire_question";

@Component({
	selector: "end-crypto-journey",
	templateUrl: "./end-crypto-journey.component.html",
	styleUrls: ["./end-crypto-journey.component.scss"],
	standalone: false
})
export class EndCryptoJourneyComponent implements OnInit {
	@Input() public question: QuestionnaireQuestion;

	public ngOnInit(): void {
		this.question.getAnswers().forEach((a) => a.setSelected(true));
	}
}
